export const slugify = (value = '') => {
  return String(value)
    .toLowerCase()
    .trim()
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
};

export const buildBlogPath = (blog) => {
  const slug = slugify(blog?.title || '');
  const id = blog?._id || blog?.id || '';
  if (!id) return slug ? `/blog/${slug}` : '/blogs';
  return slug ? `/blog/${slug}/${id}` : `/blog/${id}`;
};
